import React, { useState } from "react";
import MessageList from "./MessageList";
import MessageContent from "./MessageContent";
import { useLocation, useSearchParams } from "react-router-dom";
import { useEffect } from "react";

const MessagesSection = ({ showUnread,setShowChat,showChat }) => {
  // const [search, setSearch] = useState("");
  const [activeChat, setActiveChat] = useState(null);
  const [searchParams] = useSearchParams();
  const chatIdFromUrl = searchParams.get("chatId");
  const companyIdFromUrl = searchParams.get("companyId");

  // const isMobile = window.innerWidth < 768;
  const [isMobile, setIsMobile]= useState(window.innerWidth<768)
  const location = useLocation();
  const isCompanyInbox = location.pathname === "/inbox";
  const [selectedCompany, setSelectedCompany] = useState(null); // { value, name }

  useEffect(() => {
    if (!isCompanyInbox) return;
    // Switching company should reset current chat view
    setActiveChat(null);
    setShowChat(false);
  }, [isCompanyInbox, selectedCompany?.value]);

  useEffect(() => {
    // ✅ Reset chat when switching between inbox/unread
    setActiveChat(null);
    setShowChat(false);
  }, [showUnread]);

  useEffect(()=>{
    const handelMobile =()=>{
      setIsMobile(window.innerWidth<768)
    }
    window.addEventListener("resize", handelMobile)
    return()=> window.removeEventListener("resize",handelMobile)

  },[])
  return (
    <section className="flex flex-col md:flex-row h-full overflow-hidden">
      <div
        className={`w-full md:w-[30%] overflow-hidden border border-gray-200 ${showChat ? "hidden md:block" : "block"}`}
      >
        <MessageList
          showUnread={showUnread}
          selectedCompany={selectedCompany}
          onSelectedCompanyChange={setSelectedCompany}
          defaultCompanyId={companyIdFromUrl}
          onSelectChat={(chat) => {
            setActiveChat(chat);
            setShowChat(true);
          }}
           defaultChatId={isMobile ? null : chatIdFromUrl}
          // defaultChatId={chatIdFromUrl}
        />
      </div>

      <div
        className={` w-full md:w-[70%] ${!showChat ? "hidden md:block" : "block"}  overflow-hidden border border-gray-200`}
      >
        <MessageContent
          activeChat={activeChat}
          selectedCompany={selectedCompany}
          companyIdFromUrl={companyIdFromUrl}
          onBack={() => setShowChat(false)}
        />
      </div>
    </section>
  );
};

export default MessagesSection;
